<ng-container *ngIf="menuLinks">
  <!-- Personal menu navigation -->
  <div class="nav nav--hamburger">
    <div class="button--menu" role="button" #hamburgerNavigationTrigger>
      <div class="icon--hamburger" [ngClass]="{ 'icon--hamburger--expanded': isOpen }">
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
    <air-navigation
      [name]="'hamburger-menu'"
      [navigationItems]="menuLinks"
      [navigationTrigger]="hamburgerNavigationTrigger"
      [userEventSource]="userEventSource"
    ></air-navigation>
  </div>
</ng-container>
